import React from "react";
import { Search, X, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface OpportunitySearchBarProps {
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
}

export const OpportunitySearchBar: React.FC<OpportunitySearchBarProps> = ({
  value,
  onChange,
  isLoading = false,
}) => {
  const handleClear = () => {
    onChange("");
  };

  return (
    <div className="relative flex-1 max-w-sm">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground/60" />
      <Input
        type="text"
        placeholder="Search opportunities..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-20 h-8 rounded-md"
      />
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {isLoading && (
          <Loader2 className="h-3 w-3 text-muted-foreground/60 animate-spin" />
        )}
        {value && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClear}
            className={cn(
              "h-5 w-5 p-0 hover:bg-muted rounded-full",
              "flex items-center justify-center",
            )}
          >
            <X className="h-3 w-3 text-muted-foreground" />
          </Button>
        )}
      </div>
    </div>
  );
};
